import { Visibility } from '@mui/icons-material';
import {
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';

import { ProcessedEntry } from '../types';

interface InvalidEntriesTableProps {
  entries: ProcessedEntry[];
  onViewLines: (e: React.MouseEvent, entry: ProcessedEntry) => void;
}

const InvalidEntriesTable: React.FC<InvalidEntriesTableProps> = ({
  entries,
  onViewLines,
}) => {
  if (entries.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 48 }}></TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell align="right">Líneas</TableCell>
              <TableCell>Errores</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {entries.map((processedEntry, index) => {
              return (
                <TableRow
                  key={`invalid-${index}`}
                  hover
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell onClick={(e) => e.stopPropagation()}>
                    <IconButton
                      size="small"
                      onClick={(e) => onViewLines(e, processedEntry)}
                      title="Ver líneas"
                    >
                      <Visibility fontSize="small" />
                    </IconButton>
                  </TableCell>
                  <TableCell>{processedEntry.entry.name}</TableCell>
                  <TableCell>{processedEntry.entry.date}</TableCell>
                  <TableCell align="right">
                    {processedEntry.entry.lines.length}
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="error"
                      sx={{
                        maxWidth: 400,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                      title={processedEntry.errors.join('; ')}
                    >
                      {processedEntry.errors.join('; ')}
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default InvalidEntriesTable;
